import { useState, useEffect } from "react";
import PropTypes from 'prop-types';
import Modal from "../modal";
import { getConsultInt, ActualizaConsult } from "../../services/office";
import { ErrorContext } from "../../utils/context/error";

function OfficeModal({ show, AreaI, AreaFId, ConsultI, Tag, handleshow, handleFiltrar }) 
{
  const [habilita, setHabilita] = useState(false);
  const [areaId, setAreaId] = useState(0);
  const [consultId, setConsultId] = useState(0);
  const [nombreConsult, setNombreConsult]= useState("");
  const [codigoConsult, setCodigoConsult] = useState("");
        
  const [area, setArea] = useState([]);
  const [Titulo, setTitulo] = useState("");
  const { setShowToast, setOpciones } = ErrorContext();
  
  
  //Boton Cancelar
  const handleCancel = async () => 
    {
      setHabilita(false);
      handleshow(false);
    };
   
  // Boton Aceptar
  const handleAceptar = async () => 
    {
       setHabilita(true);
       setShowToast(false);
       const response = await ActualizaConsult({
          areaId,
          consultId,
          codigoConsult,
          nombreConsult,
          Tag
        });
        if (response) 
          {
             if (response.status === 200) 
              {
                setHabilita(false); 
                handleFiltrar(AreaFId);
                handleshow(false);
              } 
             else 
             {
               const Mensaje = response.message;
               const opc = { type: "Danger", message: Mensaje, active: true };
               setOpciones(opc);
               setShowToast(true);
             }
          }
      setHabilita(false);    
    };

    // Medico por Area e Id
    const fillConsultInt = async (AreaId, ConsultId) => 
      {
        setShowToast(false);
        const response = await getConsultInt(AreaId, ConsultId);
        if (response) 
          {
            if (response.status === 200) 
              {
                setArea(response.data.area);
                setNombreConsult(response.data.data[0]?.NombConsult||"");
                setCodigoConsult(response.data.data[0]?.CodConsult)||"";
                setConsultId(response.data.data[0]?.ConsultId||0);
              } 
            else 
              {
                 const Mensaje = response.message;
                 const opc = { type: "Danger", message: Mensaje, active: true };
                 setOpciones(opc);
                 setShowToast(true);
              }
          }
        else
        {
           const Mensaje = response.message;
           const opc = { type: "Danger", message: Mensaje, active: true };
           setOpciones(opc);
           setShowToast(true); 
        }  
     };
   
    useEffect(() => 
      {
         if (show) 
         {
            setHabilita(false); 
            setNombreConsult("");
            setCodigoConsult("");
            setAreaId(AreaI);
            setConsultId(ConsultI);
            fillConsultInt(AreaI, ConsultI);
            if (Tag !== 0) 
              {
                 if (Tag === 1) setTitulo("Editar Consultorio (" + ConsultI + ")");
                 if (Tag === 2) setTitulo("Eliminar Consultorio (" + ConsultI + ")");
              } 
            else 
            {
               setConsultId(0);
               setTitulo("Crear Consultorio");
            }
         }
     }, [show]);

  return (
    <>
     <Modal isOpen={show} onClose={()=>handleshow(false)} title={Titulo}>
          <div className="flex lg:w-[25rem]">
              <form noValidate className="flex flex-col w-full">
                  <div className="flex flex-col w-full h-full ">
                        <div className="w-full">
                            <label>Area</label>
                              <select id="area" name="area" value={areaId || 0} onChange={(e) => setAreaId(e.target.value)} label="Area" disabled={Tag === 2 || Tag === 1}>
                                  <option value={0} disabled>
                                      Seleccionar una Area...
                                  </option>
                                  {area.map((item) => {
                                     return (
                                         <option key={item.AreaId} value={item.AreaId}>
                                            {item.NombreArea}
                                         </option>
                                      );
                                   })}
                              </select>
                         </div>      
                         <div className="w-full mt-4">
                            <label>Código</label>
                              <input type="text" name='searchid' value={codigoConsult || ""} placeholder="Código del Consultorio..." 
                                       onChange={(e)=> setCodigoConsult(e.target.value)}
                                autoComplete="off" 
                                disabled={Tag === 2 || Tag === 1}></input>
                         </div>

                         <div className="w-full mt-4">
                            <label>Nombre</label>
                              <input type="text" name='searchid' value={nombreConsult || ""} placeholder="Nombre del Consultorio..." 
                                       onChange={(e)=> setNombreConsult(e.target.value)}
                                autoComplete="off" 
                                disabled={Tag === 2}></input>
                         </div>
                      
                  </div>
                  <div className="flex w-full gap-4 mt-6 justify-end">
                          <button name="Aceptar" className="btnprimary" onClick={handleAceptar} disabled={habilita} type="button">Aceptar</button>
                          <button name="Cancelar" className="" onClick={handleCancel} disabled={habilita} type="button">Cancelar</button>
                  </div> 
              </form> 
          </div> 
    </Modal>          

    </>
  );
}
OfficeModal.propTypes = {
  show: PropTypes.bool.isRequired,
  AreaI: PropTypes.number.isRequired, 
  AreaFId: PropTypes.number.isRequired, 
  ConsultI: PropTypes.number.isRequired,
  Tag: PropTypes.number.isRequired,
  handleshow: PropTypes.func.isRequired,
  handleFiltrar: PropTypes.func.isRequired,
};

export default OfficeModal;
